export interface careerCard {
  id: number;
  name: string;
  title: string;
  description1: string;
  description2?: string;
  imgSrc: string;
  imgAlt: string;
  reverseLayout?: boolean; // optional flag if you want to flip the image/text side
}

// The style for cards with background gradient
export const bgGradientStyle = {
  background:
    "linear-gradient(309.45deg, rgba(0, 167, 89, 0.08) 24.42%, rgba(0, 163, 212, 0.08) 69.56%)",
};

export const bgwhiteStyle = {
  background:
    "white",
};

// Data for leadership cards
export const carrerCardData: careerCard[] = [
  {
    id: 1,
    name: "S Murali Krishna Pasumarthi",
    title: "Chairman & Managing Director",
    description1:
      "Intron Life Sciences offers a professional working environment with a high potential for growth. Job experience at Intron is a challenging and enjoyable that allows one to realise and exploit the innate potential and fulfill one's aspirations. Intron highly encourages professionalism with commitment and values with a high accent on business and professional ethics and politics are a strict no no.Intron being on a path of constant innovation and customer relevance offers exciting career opportunities for growth and invites players across various functions and specialities to come aboard.",
    description2:
      "Interested candidates may mail their CVs to careers@intronlifesciences.com",
    imgSrc: "/img/career/career_img_3.png",
    imgAlt: "career",
    reverseLayout: false,
  },
  // add as many cards as you want...
];
